import { Icon } from 'antd';
import React from 'react';

const SortableHeader = ({ sortOrder, columnTrue }) => {
  return (
    <div style={{ marginLeft: 5, display: 'flex', flexDirection: 'column', paddingTop: '5px' }}>
    <Icon
      type="caret-up"
      style={{
        fontSize: '10px',
        color: sortOrder === 'ascend' && columnTrue ? '#1890ff' : '#ccc',
      }}
    />
    <Icon
      type="caret-down"
      style={{
        fontSize: '10px',
        color: sortOrder === 'descend' && columnTrue ? '#1890ff' : '#ccc',
        position: 'relative',
        top: '-3px'
      }}
    />
  </div>
  
  );
};

export default SortableHeader;